export default __webpack_public_path__ + "static/sneakers.cover-93400c3e10e8a6885adba77baa6ac8d9.jpg";